export default __webpack_public_path__ + "5440bd0bfb4ca83e11f8dc29b7d12633.png";